<div mat-dialog-title class="dialog-header d-flex justify-content-between">
  <div i18n="@@referenceDetails">Reference Details</div>
  <mat-icon (click)="closeDialog()" class="cursor" i18n-label="@@closeDialog" aria-label="Close">close</mat-icon>
</div>

<mat-dialog-content>
  <div class="cards-container">
    <mat-card class="icons-card mb-16">
      <mat-card-content>
        <mat-icon class="mr-10" color="accent" i18n-label="@@instituteIcon" aria-label="Institute">location_city</mat-icon>
        <div>
          <div class="mb-12">{{reference.instituteName}}</div>
          <div class="d-flex align-items-center mat-caption">
            <div matTooltip ellipsisTooltip>{{reference.instituteDepartment}}</div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card class="icons-card mb-16">
      <mat-card-content>
        <mat-icon class="mr-10" color="accent" i18n-label="@@personIcon" aria-label="Person">person</mat-icon>
        <div>
          <div class="mb-12">{{reference.contactName}}</div>
          <div class="d-flex align-items-center mat-caption mb-10">
            <mat-icon class="mr-10" i18n-label="@@emailIcon" aria-label="Email">mail</mat-icon>
            <div matTooltip ellipsisTooltip>{{reference.contactEmail}}</div>
          </div>
          <div class="d-flex align-items-center mat-caption mb-10">
            <mat-icon class="mr-10" i18n-label="@@phoneIcon" aria-label="Phone">local_phone</mat-icon>
            <div matTooltip ellipsisTooltip>{{reference.contactCountryCode}}{{reference.contactPhone}}</div>
          </div>
          @if (reference.quote) {
            <div class="d-flex align-items-center mat-caption">
              <mat-icon class="mr-10" svgIcon="qoute" i18n-label="@@quoteIcon" aria-label="Quote"></mat-icon>
              <div matTooltip ellipsisTooltip>{{reference.quote}}</div>
            </div>
          }
        </div>
      </mat-card-content>
    </mat-card>
    <mat-expansion-panel class="mb-16">
      <mat-expansion-panel-header>
        <mat-panel-title i18n="@@departments">Departments</mat-panel-title>
      </mat-expansion-panel-header>
      @for (department of reference.departmetns; track department) {
        <div class="mat-caption mb-28" matTooltip ellipsisTooltip>{{department.name}}</div>
      }
    </mat-expansion-panel>
    <mat-card class="used-on-mobile">
      <mat-card-content>
        <div i18n="@@allowConnected" class="mat-subtitle-1 d-inline" matTooltip ellipsisTooltip>Allowed to be connected</div>
        @if (reference.allowedToBeConnected) {
          <div class="mat-caption d-inline" i18n="@@yes">Yes</div>
        }
        @if (!reference.allowedToBeConnected) {
          <div class="mat-caption d-inline" i18n="@@no">No</div>
        }
      </mat-card-content>
    </mat-card>
    <!-- <mat-card *ngIf="authService.getUserData().type === utils.userTypes.Distributor" class="used-on-mobile">
    <div i18n="@@usedOnMobile" class="mat-subheading-2">Use on mobile</div>
    <mat-checkbox data-testid="used_on_mobile_check" (change)="usedOnMobileToggle($event)" color="accent" i18n-label="@@usedOnMobileCheckbox" aria-label="Use on mobile"></mat-checkbox>
  </mat-card> -->
  </div>
</mat-dialog-content>